import React, { Component } from "react";
import logo from "../images/genesys-logo.png";
import logo_2x from "../images/genesys-logo@2x.png";
import { Translate } from "react-localize-redux";

class Header extends Component {
  constructor(props){
    super(props);
    this.state = {
      ctaShow: true,
      demo:window.demo
    };
  }
  render() {
    let queryArray =
      window.location.pathname.substring(1, 6).length > 0
        ? window.location.pathname.substring(1, 6).split("&")
        : [];
    // queryArray.unshift("cid=7010d000000mYj7");
    let queryString = "/";
    queryArray.forEach(function(value, index) {
      queryString += value;
      if (index < queryArray.length - 1) {
        queryString += "";
      }
    });

    if (!queryString.includes("-")) {
      queryString = "";
    }

    let ctaString = window.location.search.substring(1, window.location.search.length);
    if (ctaString.includes("site=zinfi")) {
      this.state.ctaShow = false;
    }

    return (
      <header className="header">
        <div className="row align-items-center">
          <div className="col">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://genesys.com"
            >
              <img
                src={logo}
                srcSet={`${logo} 1x, ${logo_2x} 2x`}
                className="logo"
                alt="logo"
              />
            </a>
            <h1>
              <Translate id="headerTitle" />
            </h1>
          </div>
          <div className="col">
            <a
              className={ this.state.ctaShow ? "fill-next-button header-cta" : "zinfi" }
              target="_blank"
              href={`https://www.genesys.com${this.state.demo}/request-a-demo?cid=7010d000000mYj7`}
            >
              <Translate id="headerCallToAction" />
            </a>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.jsx